// ─── Feuille « Paramètres du compte » (Core) ──────────────────────
// Ouverte en tapant l'identité (avatar + nom) en haut du Profil — PAS la
// double flèche à droite, réservée au switch entre comptes (cf. EcranProfil).
// Pour l'instant : le nom d'utilisateur (unique dans toute la suite, cf.
// services/nomUtilisateur.js). D'autres réglages de compte pourront s'y
// ajouter plus tard.
import React, { useEffect, useState } from 'react';
import { Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';
import { useUI } from '../theme/PreferencesUI';
import { useLangue } from '../i18n/LangueContext';
import Feuille from '../ui/Feuille';
import { changerNomUtilisateur } from '../services/nomUtilisateur';

export default function FeuilleParametresCompte({ visible, uid, nomActuel, onFermer }) {
  const UI = useUI();
  const s = makeStyles(UI);
  const langueCtx = useLangue() || {};
  const t = langueCtx.t || ((k) => k);
  const [nom, setNom] = useState(nomActuel || '');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => { if (visible) { setNom(nomActuel || ''); setErr(''); } }, [visible, nomActuel]);

  const modifie = nom.trim() !== (nomActuel || '') && nom.trim().length > 0;

  async function enregistrer() {
    setBusy(true); setErr('');
    try {
      await changerNomUtilisateur(uid, nom);
      onFermer?.();
    } catch (e) {
      setErr(t(`profil.nomUtilisateurErreur.${e?.code || 'inconnue'}`));
    } finally { setBusy(false); }
  }

  return (
    <Feuille visible={visible} titre={t('profil.parametresCompte')} emoji="⚙️"
      hauteur={0.42} onFermer={onFermer}
      action={{ icone: '💾', onPress: enregistrer, disabled: !modifie || busy, label: t('commun.enregistrer') }}>
      <Text style={s.lbl}>{t('profil.nomUtilisateur')}</Text>
      <TextInput style={s.input} value={nom} onChangeText={setNom} autoCapitalize="words"
        placeholder={t('profil.nomUtilisateurPlaceholder')} placeholderTextColor={UI.faint} />
      <Text style={s.aide}>{t('profil.nomUtilisateurAide')}</Text>
      {!!err && (
        <TouchableOpacity style={s.err} onPress={() => setErr('')}>
          <Text style={s.errTxt}>⚠️ {err}</Text>
        </TouchableOpacity>
      )}
    </Feuille>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  lbl:  { fontSize: 12.5, fontWeight: '700', color: UI.muted, marginTop: 14, marginBottom: 6 },
  input:{ borderWidth: 1, borderColor: UI.border, borderRadius: 12, paddingHorizontal: 14, paddingVertical: 10,
          fontSize: 15, color: UI.ink, backgroundColor: UI.card },
  aide: { fontSize: 12, color: UI.faint, marginTop: 8 },
  err:  { marginTop: 12, backgroundColor: UI.dangerTint, borderRadius: 10, borderWidth: 1, borderColor: UI.danger, padding: 10 },
  errTxt:{ color: UI.danger, fontSize: 12.5, fontWeight: '600' },
});
